import { render, staticRenderFns } from "./ContributorsEdit.vue?vue&type=template&id=47483f42"
import script from "./ContributorsEdit.vue?vue&type=script&lang=js"
export * from "./ContributorsEdit.vue?vue&type=script&lang=js"
import style0 from "./ContributorsEdit.vue?vue&type=style&index=0&id=47483f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports